import axios from "axios";

export const checkDomain = (domain) => {
  return axios.get(
    `${process.env.VUE_APP_API_URL}/clients/check?domain=${domain}`
  );
};
